import { render, staticRenderFns } from "./addUser2.vue?vue&type=template&id=a9bb7ece&scoped=true"
import script from "./addUser2.vue?vue&type=script&lang=js"
export * from "./addUser2.vue?vue&type=script&lang=js"
import style0 from "./addUser2.vue?vue&type=style&index=0&id=a9bb7ece&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9bb7ece",
  null
  
)

export default component.exports